(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2003],{

/***/ 63462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/my-inventory-report-poshmark/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-01-22",
      tag: "Poshmark",
      title: "Poshmark My Inventory Report 101 ",
      children: ["s", /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Poshmark Inventory is a useful tool for Poshmark sellers. The report provides insights into the products performing well, items with high engagement, and more. It's easy to use and gives you everything you need to make smart decisions about your Poshmark business.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This article will discuss everything you need to know about Poshmark ", /*#__PURE__*/(0,jsx_runtime.jsx)("em", {
          children: "My Inventory Report"
        }), ", including what it is, details you can see, and how it can help your Poshmark business grow.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What is My Inventory Report "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This report is a great way to keep track of your listings and how they are doing. You can easily find out the date of when you listed something, what category it's in, what price you set for it, how many views it has had on Poshmark.com, etc.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This report will outline them by type, quantity, cost, and listing price, which you can see in the summary tab. You can also see how much they've sold for or what their \"best offer\" was if someone made one on it. It's a great way to keep track of what you have available!", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What's On My Inventory Report"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This report provides valuable details about your available listings and performance in one inventory dashboard.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Here are other things you can find on the Inventory Report dashboard: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Listing Date"
          }), " - The exact date you first listed an item in your Poshmark closet", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Number of Days Listed"
          }), " - This is the length of time on how many days your items have been listed. If your item has been sitting in your closet long enough, you can try using \"offers to likers\" or price drop for a higher chance of making a sale.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "SKU"
          }), " - You can add a unique code to each of your available listings under additional fields to stay on top of your Inventory. You can also easily find an item with an SKU number instead of manually finding it in your closet.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Product Description"
          }), " - This is where you can input relevant information about the item you are selling, including a catchy listing title, category, item's condition, and more.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Cost Price"
          }), " - You can keep tabs on your profit by noting the original amount you paid for the item under additional fields (private.)", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Likes"
          }), " - You can see the number of likes your item received and use \"offer to likers\" for a higher chance of making a sale.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Available Units"
          }), " - You can see here the number of available items in a multi-unit listing."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Size"
          }), " - You can monitor here available size for each item in a listing", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Lowest Listing Price"
          }), " - This is the lowest historical price you've ever listed the item.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Current Listing Price"
          }), " - This is the current price the item is presently listed in your closet.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Other Additional Private Information"
          }), " - This tab contains private information you've placed under additional private listing fields. This is private and can also be seen by the seller.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How it Works "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This report works by showing your list of products that are currently available in your Poshmark closet, then separating them into sections based on the type of product they are. You can get your report using the app or a desktop.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "In the Poshmark App:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Step 1:"
        }), " Go to your Account Tab", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Step 2:"
        }), " Click \"My Seller Tools\"", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Step 3:"
        }), " Select \"My Inventory Report\"", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "On the Web:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Step 1:"
        }), " Go to your Account Tab"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Step 2:"
        }), " Below your profile picture, click the dropdown menu", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Step 3:"
        }), " Tap Order Activity, and select \"My Inventory report\"", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You can download it on the web to easily access your report file in Microsoft excel. In this way, you can develop different strategies to boost your views and increase your sales.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to Manage Your Listing Using My Inventory Report "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Inventory and sales report provides all the information you need to improve your sales and listing performance. Unfortunately, many Poshmark resellers do not know how to read, use, or manage their listings using this report. This report provides a way to see the items that are selling well, which items need updating, and which categories have better profit margins. It's essential to know these things so you can decide how much time and money to spend on specific listings."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Here are some tips and tricks on managing your listings using my inventory report and making the most of it."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "1. Optimization"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This report helps you track which item sells well and needs to revamp. You may optimize slow-moving items to be seen by more Poshmark users. There is still no formula on how the Poshmark algorithm works, but optimizing your listing will do the work.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Here are some things to consider in optimizing your listing: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Listing Title"
          }), " - Make sure your listing title has all its relevant keywords such as the brand name, item name, color, size, and the item's condition. This way, customers looking for a specific brand or item can easily see your listings. Adding other important information such as its color, size, and condition will lessen possible questions from potential customers, which in return, can make their buying decision quicker."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Quality Photo"
          }), " - Photos are the game changer for buying and selling something online. Make sure your listing has a high-resolution cover photo. If you are selling clothes, try to model them so customers can see the item's fit.", /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["For accessories or home decors, take a photo in a well-lighted area and take multiple shots at a different angle. There are also many photo editing apps that you can use to enhance the quality of your photo and remove unwanted elements from your pictures. Remember to take pictures of any damages, stains, holes, or signs of wear and tear (if applicable) to avoid unnecessary refunds and problems in the future.", ' ']
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Closet Organization"
          }), " - You can also take advantage of organizing your closet to get more views and sales. Ideally, you may want to organize your closet so that customers will get a good grasp of what your wardrobe is all about. If you are selling seasonal items, let the previous item sit on the bottom of your closet, then share or relist it when the season rolls out."]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "2. Price Drop and Offers to Likers "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Managing your listing using the reports provided also lets you decide well on which seller's tools and features to use to get a higher chance of selling an item. Let's break down the two Poshmark seller's tools and see how they help your Poshmark business.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Offers to Likers"
        }), ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This feature allows you to send private offers or discounts to users who have liked your listing without lowering your items publicly. However, there are two requirements before sending a private deal to a user.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["You must offer at least 10% below the lowest offer a user has received for the same listing in the last 90 days. If this is the first time a potential buyer receives the offer, it must be 10% below its current listing price.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Your offer must include a shipping discount that will be deducted from your seller's income. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Remember that any counter-offers from the potential buyers will exclude the Offer to Likers shipping discount. Additionally, sellers cannot send a new bundle offer for a single-item bundle once the potential buyer receives the offers to likers of the same listing.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "How to Send Offers to Likers: "
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to your listing "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click \"Offer / Price Drop.\" "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tap \"Offer to likers.\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Enter your offer price"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select a shipping discount "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click \"Submit.\" "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Offers with no response or action from the potential customer will expire automatically after 24 hours. "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Price Drop"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This feature allows you to drop the price of your listing. Any listings with a price drop of at least 10% will automatically notify all the users who have liked that listing about the price reduction. This notification also occasionally includes a shipping discount promotion covered by Poshmark given to a potential buyer (random).", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "How to Use the Price Drop Tool:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to your closet and select a listing "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select \"Offer / Price Drop.\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "From the list, click \"Edit listing Price (Public).\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Besides the current listing price, select the \"Price Drop Calculator\" icon. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click \"Apply Suggested Price.\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Enter your price."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tap \"Submit\" to publish the listing."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Remember that it requires a price that is 10% historically lower than your listed price. Moreover, the shipping discount covered by Poshmark only lasts within an hour, except during Closet Clear Out promotions."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "3. Relist"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Another way to manage your listing efficiently is through relisting your old item. In a simpler term, relisting simply means re-posting an existing item from your closet again. This works on seasonal products, unoptimized listing, and old listed items at the bottom of your closet.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Relisting an item is the same when creating a new listing on your Poshmark account. But, before you can relist an item, make sure you have manually removed the old existing item. In this way, you can ensure that you are not selling two exact items. This will also save you an after-sales service and the incident of selling two items on a single listing.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Poshmark also launches an easier way to relist your old Inventory. The copy listing tool allows Posh sellers to duplicate a listing easily. You may use this tool both in the app and on the web.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "In the Poshmark App:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to your Account "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select the listing you want to duplicate"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tap on \"Edit.\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Scroll down and click \"Copy Listing.\" "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select \"Yes.\" to copy the listing. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "On the Web:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to your Account tab "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select a listing. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select \"Edit Listing.\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Scroll down and select \"Copy Listing.\" "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tap \"Yes.\" to copy the listing. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["After clicking \"Yes.\", all the listing details and photos will be copied over to a new listing. If you want to modify some details or change the cover photo, you must do it manually. And just like sharing, relisting an old item can be a tedious and time-consuming task. Relisting an existing item requires a lot of time and attention. The good news is, there's a bot you can rely upon to do all this work for you.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Sellers Trusted Poshmark Bot "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["My inventory report is jampacked with all the information you need to reach your specific business goal. Unfortunately, not everyone has the knowledge and time to understand and use this report to their advantage against their competitors. Just like in any other e-commerce platform such as Depop, Mercari, and even Facebook marketplace, you have to exert time and effort to make it work.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["We at OneShop understand the challenges that most of us face every single day. This is why our team designed a bot intended to help you have a smooth and seamless reselling business. Our system acts as your marketing expert 24/7 that will do all the tedious and time-consuming tasks like sharing, following, sending offers, and even re-listing for you!", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You no longer have to worry about manually copying and editing your listing one by one. Our intelligent system does all the manual work for you, so you can focus more on other essential things such as sourcing, shipping, and time for you and your loved ones.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["OneShop offers a 7-day free trial with a reliable support team that will walk you through the whole process. Sign up now!", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/my-inventory-report-poshmark.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Poshmark My Inventory Report 101 "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Poshmark Inventory is a useful tool for Poshmark sellers. The report provides insights into the products performing well, items with high engagement, and more. It's easy to use and gives you everything you need to make smart decisions about your Poshmark business. "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/my-inventory-report-poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/my-inventory-report-poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Poshmark My Inventory Report 101 "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Poshmark Inventory is a useful tool for Poshmark sellers. The report provides insights into the products performing well, items with high engagement, and more. It's easy to use and gives you everything you need to make smart decisions about your Poshmark business. "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 73869:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/my-inventory-report-poshmark",
      function () {
        return __webpack_require__(63462);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(73869); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);